moduleContentAnimate = angular.module('contentAnimate.initializer', [])

moduleContentAnimate.service 'ContentAnimate', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  contentAnimate =
    init: (y) ->
      Y = y
      @initSections()
    findSections: ->
      Y.all(ns.sectionClass)
    checkIfInView: (section) ->
      $window = $(window)
      windowHeight = $window.height()
      windowTopPosition = $window.scrollTop()
      windowBottomPosition = windowTopPosition + windowHeight
      jSection = $(section._node)
      $animationWidgets = jSection.find('.str-block')
      $.each $animationWidgets, ->
        $widget = $(this)
        elementHeight = $widget.outerHeight()
        elementTopPosition = Math.max 0, $widget.offset().top
        elementBottomPosition = elementTopPosition + elementHeight
        if elementBottomPosition >= windowTopPosition and elementTopPosition <= windowBottomPosition
          $widget.addClass 'str-widget__in-view'
        else
          $widget.removeClass 'str-widget__in-view'
        return
      return
    initSection: ($section) ->
      self = @
      animateNeed = $section.section.animate_content_type isnt "none"
      sectionId = $section.section.id
      $(window).unbind "scroll.contentAnimate.#{sectionId}"
      if animateNeed
        $sectionAnimationType = $section.section.animate_content_type
        $section.all(".str-block").addClass "str-widget__in-view_"+$sectionAnimationType
        $(window).on "scroll.contentAnimate.#{sectionId}", ->
          self.checkIfInView $section
          return
      $(window).trigger 'scroll'
      return
    destroy: (section) ->
      id = section.section.id
      $(window).unbind "scroll.contentAnimate.#{id}"
      $(section._node).find(".str-block").removeClass (index, css) ->
        return (css.match(/(^|\s)str-widget__in-view_\S+/g) || []).join(' ')
    initSections: ->
      @findSections().each @initSection, @
  contentAnimate
]




// WEBPACK FOOTER //
// ./src/app/editor/section_initializers/contentAnimate/contentAnimate.initializer.coffee